import type { IntegrationConfig } from '../../services/integrationApi';

export type InstallDestination = 'walkthrough' | 'mapping' | 'settings';

/**
 * Where the install wizard's done button takes a store that just connected: the
 * setup walkthrough while it is on and unfinished, otherwise the integration's
 * own scan (the Shopify Catalog Matching tab, the Lightspeed settings dialog). Never the
 * product browser.
 */
export function installDestination(
  integration: Pick<IntegrationConfig, 'platform' | 'setupWalkthrough'>,
  walkthroughEnabled: boolean,
): InstallDestination {
  if (walkthroughEnabled && !integration.setupWalkthrough?.completedAt) return 'walkthrough';
  return integration.platform === 'shopify' ? 'mapping' : 'settings';
}
